import { UiProgramType } from '../../enum/ui-utils.enum';

export function getProgramMainRoute(uiProgramType: UiProgramType): string {
    let mainRoute = '/';

    switch (uiProgramType) {
        case UiProgramType.Course:
            mainRoute = '/program/course/details';
            break;
        case UiProgramType.LiveWebinar:
            mainRoute = '/program/live/details';
            break;
        case UiProgramType.RecordedWebinar:
            mainRoute = '/program/recorded/details';
            break;
        case UiProgramType.Podcast:
            mainRoute = '/program/podcast/details';
            break;
    }

    return mainRoute;
}
